import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';

import Framework from '../../components/framework';
import BtnBack from '../../components/framework/btn-back';
import Trans from '../../components/translation/trans';
import useRunOnce from '../../hooks/use_run_once';
import useTranslation from '../../hooks/use_translation';

const Cookies = ({ location }) => {
	const { t } = useTranslation('cookies');

	useRunOnce({
		mount: () => {
			if (typeof window === 'undefined') return;
			if (!window?.CookieFirst?.renderEmbeds) return;
			window.CookieFirst.renderEmbeds();
		},
	});

	return (
		<Framework
			description={t('meta_description')}
			location={location}
			tags={t('meta_keywords')}
			title={t('title')}
		>
			<div className="container mt-3 pt-lg-5 article-content" id="content">
				<BtnBack url="/villkor" />

				<h1>{t('t1')}</h1>
				<Trans i18nKey="t2" t={t} />
				<div id="cookiefirst-policy-page"></div>
			</div>
		</Framework>
	);
};

Cookies.propTypes = {
	location: PropTypes.object.isRequired,
};

export default Cookies;

export const query = graphql`
	query {
		locales: allLocale {
			...translationFields
		}
	}
`;
